import QS from 'querystring';

import { randomString } from '@/utils';

export const groupStatusText = {
  WAIT_OPEN: '待开团',
  UNDERWAY: '成团中',
  SUCCESS: '拼团成功',
  FAIL: '拼团失败'
};

export const payStatusText = {
  WAIT_PAY: '待支付',
  PAY_SUCCESS: '支付成功',
  PAY_FAIL: '支付失败',
  REFUND: '退款'
};

export const groupDetailStatusText = {
  GROUP_START: '开团成功',
  GROUP_JOIN: '参团成功',
  GROUP_END: '拼团成功',
  GROUP_FAIL: '拼团失败',
  PAY_SUCCESS: '购买成功'
};

export const SiteUrl = {
  // 分享跳转海报
  SHARE: `/activity/poster/${randomString(6)}`,
  // 上传、关注跳转活动
  ACTIVE: `/activity`
};
// 获取站内跳转url
export function getJumpSiteUrl({
  action,
  activityId,
  actCode,
  channel,
  channelNo
}: {
  action: string;
  activityId: string | number;
  actCode: string;
  channel?: string;
  channelNo?: string;
}) {
  if (action === 'SHARE') {
    return `${(SiteUrl as any)[action]}?${QS.stringify({
      actId: activityId,
      actCode,
      channel,
      channelNo
    })}`;
  } else {
    return `${(SiteUrl as any).ACTIVE}/${'abc'}/${actCode}`;
  }
}

// 发放奖励类型
export const giveContentTypeText = {
  // MONEY: '现金',
  // PHYSICAL_GOODS: '实物', // id
  GOODS: '商品',
  USER_POINT: '成长豆',
  LABEL: '打标签', // id
  ASSIGN_ACT: '指定用户优惠', // id
  HUB: '内容资源'
  // LOTTERY: '抽奖',
  // COUPON: '指定活动id'
  // VIRTUAL_GOODS: '虚拟商品'
  // HUB: '资源包'
};

// 推荐人 content
export const initiativeContentText = {
  POSTER: '海报',
  SCREENSHOT: '截图',
  WECHAT_PUBLIC_ACCOUNT: '公众号',
  EXPERIENCE_PACKAGE: '体验包'
};

// 推荐人行为
export const initiativeActionText = {
  SHARE: '分享',
  UPLOAD: '上传',
  FOLLOW: '关注',
  BUY: '购买'
  // LIFE_CYCLE_FIRST_UPLOAD: '生命周期首次上传',
};

export const InitiativeFrequencyText = {
  DAY: '每X天',
  TIME: '每X次',
  PERSON: '每X人'
};

// 被推荐人  内容
export const PassiveContentText = {
  EXPERIENCE_PACKAGE: '体验包',
  SYSTEM_PACKAGE: '系统包'
  // SEGMENT_PACKAGE: '主题包',
  // RESOURCE_PACKAGE: '资源包',
  // ALBUM: '专辑',
  // AUDIO: '音频',
};

// 被推荐人的 发放时机行为重定义
export const CustomerAction = {
  BUY: '购买',
  CLASS_BEGIN: '体验',
  CLASS_FINISH: '完成',
  SUBSCRIBE_BUY: '购买',
  PARTITION_BUY: '购买'
};

// 奖励发放时机的行为对应
export const PriceGetTimeActionText = {
  // 推荐人
  FOLLOW: '关注',
  BUY: '购买',
  SHARE: '分享',
  UPLOAD_SCREENSHOT_CHECK_PASS: '截图审核通过',
  UPLOAD_SCREENSHOT_FIRST_CHECK_PASS: '首次审核通过',
  // 被推荐人的
  CLASS_BEGIN: '开课',
  CLASS_FINISH: '完课',
  SUBSCRIBE_BUY: '购买',
  PARTITION_BUY: '购买',
  PARTIAL_COMPLETE: '完课',
  FULL_COMPLETE: '完课'
};

export const PAGE_LOADING_STOP = 'page_loading_stop';

export const shareTypeText: any = {
  h5: 'H5领课',
  dynamic_mini_program: '小程序领课',
  mini_program_code: '小程序码领课'
};

// 发放维度：ONCE-活动期间仅一次，PERSON_COUNT-按动作人数累计，ACTION_COUNT-动作次数累计
export type DimensionType = 'ONCE' | 'PERSON_COUNT' | 'ACTION_COUNT';

// 规则动作文案映射（29 种 ActionType）
export const RuleActionText: Record<string, string> = {
  // 分享传播
  SHARE: '分享海报',
  GROUP_SHARE: '拼团分享',
  // 购买支付
  BUY: '购买',
  SUBSCRIBE_BUY: '订阅购买',
  PARTITION_BUY: '购买',
  GROUP_BOOKING_ORDER: '拼团下单',
  PAY_SUCCESS: '支付',
  // 课程学习
  CLASS_BEGIN: '开课',
  CLASS_FINISH: '结课',
  USER_COURSE_ACTIVATED: '激活课程',
  ATTEND_CLASS: '首次学习',
  PARTIAL_COMPLETE: '学完',
  FULL_COMPLETE: '全部学完',
  // 扫码 / 上传 / 审核
  SCAN_CODE: '扫码',
  UPLOAD: '上传',
  UPLOAD_SCREENSHOT_CHECK_PASS: '截图审核通过',
  UPLOAD_SCREENSHOT_FIRST_CHECK_PASS: '首次审核通过',
  // 关注 / 预约 / 报名
  FOLLOW: '关注',
  RESERVE: '预约',
  SIGN_UP: '报名',
  // 抽奖 / 兑换
  LOTTERY: '抽奖',
  USER_POINT_BUY_LOTTERY: '学豆兑换抽奖',
  DISTRIBUTE_LOTTERY_COUNT: '发抽奖次数',
  PRIZE_POOL_EXCHANGE: '奖池兑换',
  REDEEM_CODE_EXCHANGE: '激活码兑换',
  EXCHANGE_SUCCESS: '兑换成功',
  // 其他
  ADD_TEACHER_SUCCESS: '加老师成功',
  VISIT_PAGE: '访问页面',
  SYSTEM_PACKAGE_CONVERSION_REFERRAL: '转化系统包'
};
